import React, { useState } from 'react';
import { Container, Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';

function Register() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate();
    const handleLoginRedirect = () => {
        navigate('/login');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('https://api.lexikonn.eu/mau/register.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ username, password, password2 }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Registrace selhala.');
            }

            localStorage.setItem('mau_user', data.user);
            window.location.href = "/"

        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <Container>
            <div className="mt-5">
                <div className="lead mb-3">Nová registrace</div>
                {error && <div className="text-danger mb-3">{error}</div>}
                <form onSubmit={handleSubmit}>
                    <input
                        className="form-control mb-3"
                        type="text"
                        name="username"
                        placeholder="Jméno"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <input
                        className="form-control mb-3"
                        type="password"
                        name="password"
                        placeholder="Heslo"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input
                        className="form-control mb-3"
                        type="password"
                        name="password2"
                        placeholder="Heslo znovu"
                        value={password2}
                        onChange={(e) => setPassword2(e.target.value)}
                    />
                    <div className="text-center">
                        <button className="btn btn-success" type="submit"><i className="bi bi-box-arrow-in-right"></i> Registrovat
                        </button>
                    </div>
                </form>
            </div>
            <div className="text-center">
                <div>
                    <Button style={{ color: "black", textDecoration: "none" }}
                        variant="link"
                        onClick={handleLoginRedirect}
                    >
                        Již mám účet
                    </Button>
                </div>
            </div>
        </Container>
    );
}

export default Register;
